import { Redirect } from 'react-router-dom';

import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';

import { accountRoutes } from './account';
import { directoryRoutes } from './directory';
import { localizeRoutes } from '../utils/routeUtils';

import HomePage from '../components/pages/home/HomePage';
import GuidelinesPage from '../components/pages/GuidelinesPage';
import NotFoundPage from '../components/pages/notfound/NotFoundPage';
import HowItWorksPage from '../components/pages/howitworks/HowItWorksPage';
import AccountPage from '../components/pages/account/AccountPage';
import ContactRequestPage from '../components/pages/contactrequest/ContactRequestPage';
import FaqPage from '../components/pages/faq/FaqPage';
import CashbackDirectoryPage from '../components/pages/directory/CashbackDirectoryPage';
import ReductionDirectoryPage from '../components/pages/directory/ReductionDirectoryPage';
import LegalNoticePage from '../components/pages/LegalNoticePage';
import MerchantCardPage from '../components/pages/merchantcard/MerchantCardPage';
import TermsPage from '../components/pages/terms/TermsPage';
import UnsubscribePage from '../components/pages/unsubscribe/UnsubscribePage';
import InterstitielComponent from '../components/pages/interstitiel/InterstitielComponent';
import ToolbarPage from '../components/pages/toolbar/ToolbarPage';
import ToolbarInstallationPage from '../components/pages/toolbar/ToolbarInstallationPage';
import LoginPage from '../components/pages/login/LoginPage';
import RegisterPage from '../components/pages/register/RegisterPage';
import PasswordResetInitFormComponent from '../components/pages/resetpassword/PasswordResetInitFormComponent';
import PasswordResetCommitFormComponent from '../components/pages/resetpassword/PasswordResetCommitFormComponent';
import ErrorEbonPage from '../components/pages/ebon/erreur/ErrorEbonPage';
import ValidationEbonPage from '../components/pages/ebon/ValidationEbonPage';
import ConfirmationEbonPage from '../components/pages/ebon/confirmation/ConfirmationEbonPage';
import TermsOfSalesPage from '../components/pages/termsofsales/TermsOfSalesPage';
import FlashingTicketPage from '../components/pages/flashing-ticket/FlashingTicketPage';
import ConfirmationEbonSmsPage from '../components/pages/ebon/sms/ConfirmationEbonSmsPage';
import ConfirmationKycPage from '../components/pages/ebon/kyc/ConfirmationKycPage';

/**
 * Routes to be prefixed with locale
 * Put all the primary routes (i.e all the routes that d'on depend on a parent route to be displaying)
 */
const localizableRoutes = [
    {
        path: PATH.HOME_PATH,
        exact: true,
        component: HomePage
    },
    {
        path: PATH.HOW_IT_WORK_PATH,
        exact: true,
        component: HowItWorksPage
    },
    {
        path: `${PATH.MERCHANTPAGE_TYPE_PATH}:query`,
        component: MerchantCardPage
    },
    {
        path: PATH.CASHBACK_PATH,
        component: CashbackDirectoryPage
    },
    {
        path: PATH.REDUCTION_PATH,
        component: ReductionDirectoryPage
    },
    {
        path: PATH.ACCOUNT_PATH,
        component: AccountPage
    },
    {
        path: PATH.FAQ_PATH,
        exact: true,
        component: FaqPage
    },
    {
        path: PATH.LEGAL_NOTICE_PATH,
        exact: true,
        component: LegalNoticePage
    },
    {
        path: PATH.TERMS_PATH,
        exact: true,
        component: TermsPage
    },
    {
        path: PATH.TERMS_OF_SALES,
        exact: true,
        component: TermsOfSalesPage
    },
    {
        path: PATH.CONTACTREQUEST_PATH,
        exact: true,
        component: ContactRequestPage
    },
    {
        path: PATH.UNSUBSCRIBE_PATH,
        exact: true,
        component: UnsubscribePage
    },
    {
        path: `${PATH.INTERSTITIEL_CASHBACK_PATH}:partnerId/:clickSource/:username?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_TOOLBAR_CASHBACK_PATH}:partnerId/:clickSource/:browser?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_REDUCTION_PATH}:partnerId/:clickSource/:couponId/:username?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_TOOLBAR_REDUCTION_PATH}:partnerId/:clickSource/:browser/:couponId`,
        component: InterstitielComponent
    },
    {
        path: PATH.TOOLBAR_PATH,
        exact: true,
        component: ToolbarPage
    },
    {
        path: PATH.TOOLBAR_POST_INSTALL_PATH,
        exact: true,
        component: ToolbarInstallationPage
    },
    {
        path: PATH.LOGIN_PATH,
        exact: true,
        component: LoginPage
    },
    {
        path: PATH.REGISTER_PATH,
        exact: true,
        component: RegisterPage
    },
    {
        path: PATH.FORGOTTEN_PASSWORD_PATH,
        exact: true,
        component: PasswordResetInitFormComponent
    },
    {
        path: `${PATH.FORGOTTEN_PASSWORD_PATH}/:email/:token`,
        exact: true,
        component: PasswordResetCommitFormComponent
    },
    {
        path: `${PATH.EBON_VALIDATION_PATH}/:query`,
        exact: true,
        component: ValidationEbonPage
    },
    {
        path: `${PATH.EBON_CONFIRMATION_PATH}:orderId?`,
        exact: true,
        component: ConfirmationEbonPage
    },
    {
        path: `${PATH.EBON_ERROR_PATH}-:id:paiement?`,
        component: ErrorEbonPage
    },
    {
        path: PATH.FLASHING_TICKET_PAGE,
        component: FlashingTicketPage
    },
    {
        path: `${PATH.VALIDATE_SMS_PATH}/:id`,
        component: ConfirmationEbonSmsPage
    },
    {
        path: PATH.KYC_CONFIRMATION_PATH,
        exact: true,
        component: ConfirmationKycPage
    }
];

export const routes = [
    ...localizableRoutes,
    ...localizeRoutes(LOCALES, localizableRoutes),
    {
        path: '/guidelines',
        exact: true,
        component: GuidelinesPage
    },
    {
        path: PATH.NOT_FOUND_PATH,
        exact: true,
        component: NotFoundPage
    },
    {
        component: Redirect,
        to: PATH.NOT_FOUND_PATH
    }
];

/**
 * First level routes + sub levels routes
 * Mainly used for breadcrumb
 */
const subRoutes = [...accountRoutes, ...directoryRoutes];

export const allRoutes = [...routes, ...subRoutes, ...localizeRoutes(LOCALES, subRoutes)];



// WEBPACK FOOTER //
// ./src/routes/index.js